var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "star-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg star",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "star") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3,31.5a1.5,1.5,0,0,1-1.1-.4,2,2,0,0,1-.8-1.9l1.5-8.8L.6,14.2a2.08,2.08,0,0,1-.5-2,1.83,1.83,0,0,1,1.5-1.3l8.7-1.3h0l3.9-8A1.85,1.85,0,0,1,15.9.5h0a1.85,1.85,0,0,1,1.7,1.1l3.9,8,8.7,1.3a1.83,1.83,0,0,1,1.5,1.3,2.08,2.08,0,0,1-.5,2L25,20.4l1.5,8.8a2,2,0,0,1-.8,1.9,1.82,1.82,0,0,1-2,.1L16,27.1,8.1,31.3A2.35,2.35,0,0,1,7.3,31.5ZM4.4,13.6l5.8,5.7-1.4,8,7.1-3.8L23,27.3l-1.4-8,5.8-5.7-8-1.2L16,5.2l-3.5,7.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.89b910679a184f88c28b08bfb07533a2.svg";
export { ForwardRef as ReactComponent };